import React from "react";
import { 
  Button, 
  Card,
  CardActions,
  Typography, 
} from "@mui/material";

const InfoCard = ({ 
  item,
  handleLink,
}) => {

  return (
    <Card 
      sx={{
        height: "90%",
        display: "flex", 
        justifyContent: "space-between", 
        flexDirection: "column",
        padding: "10px"
      }}
    >
      <Typography variant="h5" color="primary" sx={{ padding: 1 }}>
        {item.title}
      </Typography>
      <Typography variant="h2" sx={{ padding: 1, fontWeight: "bold" }}>
        {item.value}
      </Typography>
      <CardActions>
        <Typography
          variant="body2" 
          color="#737791"
        >
          {item.info}
        </Typography>
        {item.link &&
          <Button 
            onClick={handleLink}
            size="small"
            sx={{ fontSize: "14px", textTransform: "none" }}
          >
            Ver detalles
          </Button>
        }
      </CardActions>
    </Card>
  );
}

export default InfoCard;
